import { Button } from "@/components/ui/button";

interface JournalHeaderProps {
  showForm: boolean;
  onToggleForm: () => void;
}

export const JournalHeader = ({ showForm, onToggleForm }: JournalHeaderProps) => {
  return (
    <div className="flex justify-between items-center">
      <h1 className="text-3xl font-bold">Journal Entries</h1>
      <Button onClick={onToggleForm}>
        {showForm ? "Close Form" : "New Entry"}
      </Button>
    </div>
  );
};